import script from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"

import "./QandAWidget.vue?vue&type=style&index=0&id=7a61440a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a61440a"]])

export default __exports__